import {ajax} from '../utils/ajaxHelper';

// TODO make this async?
function getHouseRules({unitApiUrl, useMockData}) {
    let url = `/pdp/houseRules?unitApiUrl=${unitApiUrl}`;
    url = useMockData ? `${url}&useMockData=true` : url;

    return ajax(url);
}

export default getHouseRules;
export {getHouseRules};
